export interface SuiteUser {
  id: string;
  email: string;
  full_name: string | null;
  is_active?: boolean;
  picture_url?: string | null;
}

export interface WalletSnapshot {
  balanceUsd: number;
  currency: string;
  subscriptionActive?: boolean;
  subscriptionLabel?: string | null;
  stripeConfigured?: boolean;
  packs?: { amountUsd: number; label: string }[];
  adultOk?: boolean;
}

export interface SuiteSettings {
  forgeApiUrl: string;
  authApiUrl?: string;
}

export const DEFAULT_SUITE_SETTINGS: SuiteSettings = {
  forgeApiUrl: "http://127.0.0.1:8787",
};
